import React from "react";

import { useView } from "@wc/domain/nav/contexts/view-context";
import TeamView from "@wc/domain/teams/components/team-view";
import usePageTitle from "@wc/ui/hooks/page-title";

/**
 * @returns {React.ReactElement} The team feed page
 */
export default function Feed() {
  usePageTitle("Team Feed");

  const viewContext = useView();
  const teamId = viewContext?.selectedTeamId;

  return (
    <div>
      <TeamView teamId={teamId} />
    </div>
  );
}
